import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GeoAreaMslRespectMonitoringKpi } from 'src/app/assabil-sales/models/dtos/geo-area-msl-respect-monitoring-kpi';

@Component({
  selector: 'geo-area-msl-respect-monitoring-kpi',
  templateUrl: './geo-area-msl-respect-monitoring-kpi.component.html',
  styleUrls: ['./geo-area-msl-respect-monitoring-kpi.component.scss']
})
export class GeoAreaMslRespectMonitoringKpiComponent implements OnInit {


  @Input() geoAreaMslRespectMonitoringKpi : GeoAreaMslRespectMonitoringKpi;

  @Output() onClick        = new EventEmitter<any>();
  @Input() previousPeriod : string;

  
  constructor() { }

  ngOnInit() {
  }


  clickTitle() {

  } 
  
  click(event : any){
    this.onClick.emit(event);
  }

  clicked(){
    this.geoAreaMslRespectMonitoringKpi.expanded = !this.geoAreaMslRespectMonitoringKpi.expanded;
  }
}